import { ONBOARDING_STAGES, OnboardingDto, TherapyOption } from '@monument/core';

/**
 * Should deprecate this in favor of `OnboardingTransitionsEnum` in `shared/enums`
 */
export enum OnboardingTransitionActions {
  TEMPEST_SUBMIT_CONSENT = 'tempestSubmitConsent',
  GO_TO_SERVICE_INSURANCE = 'goToServiceInsurance',
  GO_TO_NULL_STATE = 'goToNullState',
  SKIP_INSURANCE_SUBMISSION = 'skipInsuranceSubmission',
  START_INSURANCE_SUBMISSION = 'startInsuranceSubmission',
  FINISH_INSURANCE_SUBMISSION = 'finishInsuranceSubmission',
  FINISH_INSURANCE_ELIGIBILITY = 'finishInsuranceEligibility',

  SELECT_CLINICIAN_SERVICE = 'selectCliniciansService',
  GO_TO_PHYSICIAN_SCHEDULING = 'goToPhysicianScheduling',
  CONFIRM_PHYSICIAN_APPOINTMENT = 'confirmPhysicianAppointment',
  BACK_FROM_PHYSICIAN_SCHEDULING = 'backFromPhysicianScheduling',
  RELEASE_PHYSICIAN_APPOINTMENT = 'releasePhysicianAppointment',
  GO_TO_THERAPIST_SCHEDULING = 'goToTherapistScheduling',
  CONFIRM_THERAPIST_APPOINTMENT = 'confirmTherapistAppointment',
  BACK_FROM_THERAPIST_SCHEDULING = 'backFromTherapistScheduling',
  RELEASE_THERAPIST_APPOINTMENT = 'releaseTherapistAppointment',

  CONTINUE_TO_PAYMENT = 'continueToPayment',
  BACK_FROM_PAYMENT = 'backFromPayment',
  CONTINUE_FROM_PAYMENT = 'continueFromPayment',
  BACK_FROM_PAYMENT_TO_SERVICES_SELECTION = 'backFromPaymentToServicesSelection',

  CONTINUE_TO_PROFILE = 'continueToProfile',
  SUBMIT_PERSONAL_INFO = 'submitPersonalInfo',
  SUBMIT_CONTACT_INFO = 'submitContactInfo',
  SUBMIT_EMERGENCY_CONTACT = 'submitEmergencyContact',
  SUBMIT_INTAKE = 'submitIntake',
  GO_TO_PROFILE_PERSONAL_INFO = 'goToProfilePersonalInfo',
  GO_TO_PROFILE_CONTACT_INFO = 'goToProfileContactInfo',
  GO_TO_PROFILE_EMERGENCY_CONTACT = 'goToProfileEmergencyContact',
  GO_TO_INTAKE_SURVEY = 'goToIntakeSurvey',

  RESUME_INTAKE = 'resumeIntake',

  BACK = 'back',
  COMPLETE = 'complete',
  EXIT = 'exit',
}

export const DEFAULT_GLOBAL_LOADING_TEXT = 'Please do not leave this page or refresh your browser.';

export const hasActiveOnboarding = (onboarding?: OnboardingDto) => {
  if (!onboarding) {
    return false;
  }
  return onboarding.stage !== ONBOARDING_STAGES.EXITED;
};

export const getSelectedCareOptions = onboarding => {
  if (!onboarding) {
    return {};
  }
  const hasSelectedMedication = !!onboarding.store.paymentSelection?.medication?.option;
  const hasSelectedTherapy = !!(
    onboarding.store.paymentSelection?.therapy?.option &&
    onboarding.store.paymentSelection?.therapy?.option !== TherapyOption.None
  );

  return {
    hasSelectedMedication,
    hasSelectedTherapy,
    hasOnlyMedicationCare: hasSelectedMedication && !hasSelectedTherapy,
    hasOnlyTherapyCare: !hasSelectedMedication && hasSelectedTherapy,
    hasNoSelectedCareOptions: !hasSelectedMedication && !hasSelectedTherapy,
  };
};

export const getIntervalFrequencyForTherapyOption = (therapyOption: TherapyOption) =>
  therapyOption === TherapyOption.Weekly
    ? 1
    : therapyOption === TherapyOption.Biweekly
      ? 2
      : undefined;
